import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Ornament } from "./Ornament";

const SERVICES = [
  {
    n: "01",
    t: "Destination Weddings",
    d: "Curated wedding experiences inspired by culture, aesthetics and meaningful storytelling.",
  },
  {
    n: "02",
    t: "Event Concepts & Experiential Events",
    d: "Bespoke themed concepts and immersive experiences for private clients, brands and hospitality partners.",
  },
  {
    n: "03",
    t: "Premium Entertainment",
    d: "Artistic programming, live music, performers and concept-driven entertainment through Lumière Entertainment.",
  },
  {
    n: "04",
    t: "Curated Travel & Journeys",
    d: "Destination-based experiences, retreats and guest journeys designed around discovery, culture and emotion.",
  },
  {
    n: "05",
    t: "Brand & Hospitality Experiences",
    d: "Experiential concepts for luxury hotels, resorts, hospitality groups and premium brands.",
  },
  {
    n: "06",
    t: "Creative Direction",
    d: "Concept development, storytelling and creative direction for events, campaigns and experiential projects.",
  },
  {
    n: "07",
    t: "Creative Bar Services",
    d: "Interactive bars, experiential beverage concepts, themed cocktail experiences and guest engagement activations.",
  },
  {
    n: "08",
    t: "Concept Store & Event Elements",
    d: "A curated collection of concepts, props, installations, statement pieces and experiential elements for events and hospitality projects.",
  },
  {
    n: "09",
    t: "Props, Styling & Decorative Elements",
    d: "Backdrops, tablescapes, installations, performance props and visual elements that elevate the guest experience.",
  },
];

export default function MataCantoIntro() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setVisible(true)),
      { threshold: 0.1 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      id="mata-canto"
      className="relative bg-[var(--lu-ivory)]"
      data-testid="mata-canto-section"
    >
      <div className="container-lux py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
          <div className="lg:col-span-5">
            <p className="kicker text-[var(--lu-gold-dark)]">The Brand</p>
            <h2
              className="mt-6 h-editorial text-[52px] sm:text-[74px] lg:text-[110px] text-[var(--lu-black)] leading-[0.92]"
              data-testid="mata-canto-title"
            >
              <span className="notranslate">MATA</span>
              <br />
              <span className="italic text-[var(--lu-gold-dark)] notranslate">Canto</span>
            </h2>
          </div>
          <div className="lg:col-span-7 lg:pl-12 lg:border-l border-[var(--lu-gold-dark)]/25">
            <Ornament className="mb-8 lg:ml-0" />
            <p className="text-[17px] sm:text-[19px] leading-[1.7] text-[var(--lu-black)] font-light">
              Mata Canto is a{" "}
              <span className="italic text-[var(--lu-gold-dark)]">
                luxury experience brand
              </span>{" "}
              creating immersive concepts that blend{" "}
              <span className="italic">hospitality, entertainment, travel</span> and{" "}
              <span className="italic">storytelling</span>.
            </p>
            <p className="mt-6 font-micro text-[10px] tracking-[0.32em] uppercase text-[var(--lu-gold-dark)]">Our Services</p>
          </div>
        </div>

        <div
          className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[var(--lu-gold-dark)]/20"
          data-testid="mata-canto-services"
        >
          {SERVICES.map((s, i) => (
            <article
              key={s.n}
              className={`bg-[var(--lu-ivory)] p-8 lg:p-10 hover:bg-white transition-all duration-500 ${
                visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: `${i * 80}ms` }}
              data-testid={`mata-service-${s.n}`}
            >
              <div className="flex items-start gap-4">
                <span className="font-micro text-[11px] tracking-[0.32em] text-[var(--lu-gold-dark)] pt-1 notranslate">
                  {s.n}
                </span>
                <div>
                  <h3 className="h-editorial text-[22px] lg:text-[26px] text-[var(--lu-black)] leading-[1.15]">
                    {s.t}
                  </h3>
                  <p className="mt-3 text-[14px] leading-[1.8] text-black-70 font-light">
                    {s.d}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-16 flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/services" className="btn-gold" data-testid="mata-cta-services">See all Services</Link>
          <Link to="/contact" className="btn-gold-outline" data-testid="mata-cta-contact">Start a conversation</Link>
        </div>
      </div>
    </section>
  );
}


